import React from 'react';
import H1 from 'shared/app/components/h1';

import RewardsSubnav from './subnav';

const SR6RewardsPage = () => {
  return (
    <React.Fragment>
      <RewardsSubnav />
      <H1>New Rewards Page</H1>
    </React.Fragment>
  );
};

export default SR6RewardsPage;
